import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faExclamationTriangle, faShieldHalved, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from './ServiceHistory.module.css';
import cardStyles from '../patient/CardDetails/CardDetails.module.css';

const ServiceHistoryItem = ({ data, onClick }) => {

    const formatDateTime = (dateTime) => {
        const date = new Date(dateTime);
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            timeZoneName: 'short'
        });
    };


    return (
        <div className={styles.incidentCard}>
            <div className={styles.incidentDetails}>
                <div className={cardStyles.Detail}>
                    <span className={cardStyles.DetailLabel}>Incident ID:</span>
                    <span className={cardStyles.DetailValue}>{data.id}</span>
                </div>
                <div className={cardStyles.Detail}>
                    <span className={cardStyles.DetailLabel}>Date/Time:</span>
                    <span className={cardStyles.DetailValue}>{formatDateTime(data.dateTime)}</span>
                </div>
                <div className={cardStyles.Detail}>
                    <span className={cardStyles.DetailLabel}>Description:</span>
                    <span className={cardStyles.DetailValue}>{data.description}</span>
                </div>
                <div className={cardStyles.Detail}>
                    <span className={cardStyles.DetailLabel}>Impacted Services:</span>
                    <span className={cardStyles.DetailValue}>{data.impactedServices} services</span>
                </div>
            </div>

            <button className={cardStyles.optionsButton} onClick={()=>onClick(data)}>
               View Full Details
            </button>
        </div>




    );
};

export default ServiceHistoryItem; 